import React from 'react';
import CreditHistory from '../../Components/CreditHistory';
import AppHeader from '../../Components/Common/Layout/AppHeader';
import { StyledDiv } from '../../Theme/CommonStyled';

const CreditHistoryPage: React.FC = () => {
  return (
    <>
      <AppHeader title="creditsHistory" goBack />
      <StyledDiv
        id="notification-container"
        height={'calc(100vh - 60px)'}
        overflow={'auto'}>
        <CreditHistory />
      </StyledDiv>
    </>
  );
};

export default CreditHistoryPage;
